module.exports = __webpack_public_path__ + "static/media/timelapse_25.b6e35493.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/WoodburningView/timelapse_25.jpg
// module id = 983
// module chunks = 0